import { CityType } from "@smile2impress/location-content";
import { FC, memo } from "react";
import { Flex } from "@smile2impress/components/relaunch";

import { FlagshipBadge } from "components/Relaunch/Map/components/FlagshipBadge";
import Link from "components/Link";
import { UrlsConfig } from "configs/urlsConfig";

interface CityGridItemProps {
    city: CityType;
    showFlagshipBadge: boolean;
}

export const CityGridItem: FC<CityGridItemProps> = memo(
    ({ city, showFlagshipBadge = false }) => {
        const cityTitle = city.title || city.label || "";
        const clinicId = city.clinicIds[0] || "";
        const isFlagship = showFlagshipBadge
            ? city.clinics.some((clinic) => clinic.isFlagship)
            : false;
        const clinicWithUrl = city.clinics.find(
            (clinic) => clinic.isFlagship && clinic.url
        );

        return (
            <Flex key={`${cityTitle}-${city.id}`} alignItems="center">
                <Link
                    href={
                        clinicWithUrl
                            ? `${clinicWithUrl.url}?clinicId=${clinicWithUrl.id}`
                            : `${UrlsConfig.UNIVERSAL_FORM}?location=${cityTitle}&clinicId=${clinicId}`
                    }
                    textStyle="body"
                    w="fit-content"
                    color="base.gunmetal"
                    mr="8px"
                >
                    {cityTitle}
                </Link>
                {isFlagship && (
                    <FlagshipBadge
                        bgColor="base.bitterSweet"
                        color="base.white"
                    />
                )}
            </Flex>
        );
    }
);
